
import React from "react";
import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import { ExpertCallsSection } from "@/components/home/ExpertCallsSection";
import { StickyCTABar } from "@/components/home/StickyCTABar";
import FeaturedCounties from "@/components/home/FeaturedCounties";
import FairDealGuide from "@/components/home/FairDealGuide";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import BlogHighlights from "@/components/home/BlogHighlights";
import CTASection from "@/components/home/CTASection";
import { SEOHead } from "@/components/seo/SEOHead";
import { generateOrganizationSchema, generateBreadcrumbSchema } from "@/lib/schema";

export default function Index() {
  const organizationSchema = generateOrganizationSchema();
  
  // Create breadcrumb for the home page
  const breadcrumbs = [
    { name: "Home", url: "/" }
  ];
  
  const schemas = [
    organizationSchema,
    generateBreadcrumbSchema(breadcrumbs)
  ];

  return (
    <Layout>
      <SEOHead 
        title="Grandpal | Find Nursing Homes in Ireland & Fair Deal Support"
        description="Grandpal helps families find nursing homes in Ireland and navigate the Fair Deal scheme with expert guidance and compassionate support."
        canonicalUrl="/"
        schema={schemas}
      />

      <HeroSection />
      <ExpertCallsSection />
      <FeaturedCounties />
      <FairDealGuide />
      <TestimonialsSection />
      <BlogHighlights />
      <CTASection />
      <StickyCTABar />
    </Layout>
  );
}
